import { render } from "./branchesComponent.vue?vue&type=template&id=4e9957bb"
import script from "./branchesComponent.vue?vue&type=script&lang=js"
export * from "./branchesComponent.vue?vue&type=script&lang=js"

import "./branchesComponent.vue?vue&type=style&index=0&id=4e9957bb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__